<template>
  <div id="attribution" class="cuebiq-tab-content">
    <div class="loaded" style="" id="visit-analysis">
      <div class="visit-footfall_uplift panel panel-default footfall-uplift">
        <div class="panel-heading">
          <h3>FOOTFALL UPLIFT
              <info-tooltip text="This section describes the distribution of visits by location and time.<br/>Only impressions that met the ge-targeting and visit criteria defined in the Campaign Overview section were considered on the analysis.<br/>Select an administrative area to display the visit performance or click on 'View all' to visualize the overall campaign results.">
              </info-tooltip>
            <hr>
          </h3>
        </div>
        <div class="panel-body">
          <div>
            <div class="row">
              <div class="col-xs-12" role="hideable-element">
                <ul class="buttons">
                  <li class="btn-view-all">
                    <button id="all-states" type="button" class="btn btn-primary" v-on:click="visitMap.reset();">View all</button>
                  </li>
                </ul>
              </div>
              <div class="visit-footfall_uplift_map col-xs-6" role="hideable-element" style="height: 500px;">
                <h4>Visit map
                  <info-tooltip text="The map represents the footfall uplift by state vs. the control group.">
                  </info-tooltip>
                </h4>
                <div data-pdf-generator-reference="visits-geochoropleth-heatmap-chart" class="map-legend-container clearfix">
                  <dc-map v-if="visitMapComponent" v-bind="visitMapComponent" :width="480" :height="400"></dc-map>
                </div>
              </div>
              <div class="visit-footfall_uplift-topstores col-xs-6">
                <h4>Top stores
                  <info-tooltip text="The values represent the percentage of devices that have visited each individual store vs. the total in-store visits."/>
                </h4>
                <div data-pdf-generator-reference="top-stores-table">
                  <div class="table-search">
                    <div>
                      <table id="data-table" class="table cuebiq table-search animate clickable table">
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr class="cuebiq-separator">
            <div class="footfall-uplift-details"  v-if="tab_sections.conversion_analysis_geo" >
              <conversion-analysis-geo :geodata="conversion_analysis_geo" :currentstate="selected_province"></conversion-analysis-geo>
            </div>

          </div>
        </div>
      </div>



      <div class="visit-poi_impressions_time_heatmap panel panel-default panel-default-section">
        <div class="panel-heading">
          <h3>
            TIME HEATMAP OF IMPRESSIONS THAT GENERATED POI VISITS
            <info-tooltip text="Visit rate by day of the week/time of the day.<br/>The last impression received prior to the visit is attributed the visit."/>
            <hr>
          </h3>
        </div>
        <div class="panel-body">
          <div class="row">
             <div class="col-xs-12">
                <div id="converted-impressions">
                   <div class="legend-container">
                      <div class="row">
                         <div class="converted-impressions-bucket col-xs-6">
                            <h4 class="converted-impressions-bucket-title">
                              Significance
                              <info-tooltip text="Time of the day are split by statistical relevance according to their number of impressions and unique devices.<br/>The higher these are, the more significant."/>
                            </h4>
                            <div class="pull-left">
                              <button class="btn-significance-low btn green selected">low</button>
                              <button class="btn-significance-medium btn green">medium</button>
                              <button class="btn-significance-high btn green">high</button>
                            </div>
                         </div>
                         <div class="col-xs-6">
                            <div class="legend-container">
                              <div class="legend legend--heatmap">
                                <svg width="500" height="50">
                                </svg>
                              </div>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
             </div>
          </div>
        </div>


        <div class="heatmap-block">
          <div class="barchart-hours"></div>
          <div class="heatmap"></div>
          <div class="barchart-days"></div>
        </div>
      </div>



      <div class="visit-distance_poi_key_location panel panel-default panel-default-section" v-if="tab_sections.conversion_analysis_distance">
        <div class="panel-heading">
          <h3>DISTANCE BETWEEN POI AND KEY LOCATIONS
            <info-tooltip text="The chart visualizes the percentage of devices that registered a visit based on the POI distance from consumers' home, work, and their location at the time the impression was served."/>
            <hr>
          </h3></div>
        <div data-pdf-generator-reference="distance-poi-key-locations-chart" class="panel-body">
          <div class="row">
            <div id="conversion-distance" class="col-xs-12">
              <div class="recharts-wrapper" style="position: relative; cursor: default; width: 960px; height: 400px;">
                <bar-chart :chart-data="conversion_analysis_distance" :options="conversion_analysis_distance.options"></bar-chart>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div class="visit-frequency panel panel-default panel-default-section" v-if="tab_sections.conversion_analysis_visits_exposed" >
        <div class="panel-heading">
          <h3 class="uppercase">Visit Frequency
            <info-tooltip text="The chart is distributed by the frequency of visits by users during the campaign for both exposed and control group."/>
            <hr>
          </h3>
        </div>
        <div class="panel-body">
          <div class="row">
            <div id="conversion-visit-exposed" class="col-xs-12">
              <div id="frequencyLegend" style="width: 100%;"></div>
              <div class="recharts-wrapper" style="position: relative; cursor: default; width: 960px; height: 400px;">
                <bar-chart :chart-data="conversion_analysis_visits_exposed" :options="conversion_analysis_visits_exposed.options"></bar-chart>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="visit-daily_distribution panel panel-default panel-default-section" v-if="tab_sections.conversion_analysis_timeline">
        <div class="panel-heading">
          <h3>DAILY DISTRIBUTION OF VISIT RATE
            <info-tooltip text="The chart represents a visit rate timeline for both exposed and control group.<br/>Each point represents the percentage of converted devices vs. the total universe (based on the timeframe on the x-axis)."/>
            <hr>
          </h3>
        </div>
        <div data-pdf-generator-reference="visit-rate-chart" class="panel-body">
          <div class="row">
            <div class="col-xs-12" style="margin-bottom: 10px;"><a class="btn btn-download" href="" download="visit_rate_daily_distribution.csv"><i class="fa fa-download"></i>Download</a></div>
            <div class="col-xs-12">
              <div class="recharts-wrapper" style="position: relative; cursor: default; width: 960px; height: 400px;">
                <line-chart  :chart-data="conversion_analysis_timeline" :options="conversion_analysis_timeline.options"></line-chart>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="cr" class="visit-rate_impression_frequency panel panel-default panel-default-section">
        <div class="panel-heading">
          <h3>Visit Rate per Impression Frequency
            <info-tooltip text="This section analyzes how efficiencies can be achieved for future campaigns by understanding the optimal impression frequency per user."/>
            <hr>
          </h3>
        </div>
        <div class="panel-body">
          <div class="row">
            <div class="col-xs-12">
              <h4>Visit Rate per Impression Frequency
                <info-tooltip text="The y-axis displays the visit rate while the x-axis displays the impression frequency."/>
              </h4>
              <div>
                <h5>The visit rate is <dc-number v-if="visit_rate_number_props" v-bind="visit_rate_number_props" :number-format="'0.2f'"></dc-number>%,
                  <span class="fade in"><dc-number v-if="device_perc_number_props" v-bind="device_perc_number_props" :number-format="'4.3g'"></dc-number>% of the devices were reached
                    <span>delivering <dc-number v-if="impression_perc_number_props" v-bind="impression_perc_number_props" :number-format="'4.3g'"></dc-number>% of the impressions</span>
                  </span>
                </h5>
              </div>
            </div>
            <div class="col-xs-12" data-file-controller="frequency_analysis.csv">
              <div style="float: left;">
                <div class="cuebiq-chart barchart">
                  <div id="converted-devices-rate">
                  </div>
                </div>
              </div>
              <div class="radials">
                <div class="radial devices evidence">
                  <div id="device-rate-radial" class="cuebiq-radial devices">
                    <vue-circle ref="deviceRateProgress"
                          :progress="perc_devices_reached"
                          :size="120"
                          :reverse="false"
                          line-cap="round"
                          :fill="{ color: $chartSettings['progress_circle']['fill'] }"
                          empty-fill="rgba(0, 0, 0, .1)"
                          :animation-start-value="0.0"
                          :start-angle="-1.57"
                          insert-mode="append"
                          :thickness="$chartSettings['progress_circle']['thickness']"
                          :show-percent="false">
                    </vue-circle>
                  </div>
                  <div class="metric metric--numeric  ">
                    <div class="metric__content metric__content--numeric">
                      <h3 class="metric__title metric__title--numeric"><dc-number v-if="device_perc_number_props" v-bind="device_perc_number_props" :number-format="'4.0f'"></dc-number>%</h3>
                      <p class="metric__subtitle">Devices reached</p>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="radial impressions evidence">
                    <div id="impression-rate-radial" class="cuebiq-radial impressions">
                      <vue-circle ref="impressionRateProgress"
                            :progress="perc_impressions_delivered"
                            :size="120"
                            :reverse="false"
                            line-cap="round"
                            :fill="{ color: $chartSettings['progress_circle']['fill'] }"
                            empty-fill="rgba(0, 0, 0, .1)"
                            :animation-start-value="0.0"
                            :start-angle="-1.57"
                            insert-mode="append"
                            :thickness="$chartSettings['progress_circle']['thickness']"
                            :show-percent="false">
                      </vue-circle>
                    </div>
                    <div class="metric metric--numeric  ">
                      <div class="metric__content metric__content--numeric">
                        <h3 class="metric__title metric__title--numeric"><dc-number v-if="impression_perc_number_props" v-bind="impression_perc_number_props" :number-format="'4.0f'"></dc-number>%</h3>
                        <p class="metric__subtitle">Delivered impressions</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-12">
                <ul class="campaign-properties">
                  <li><strong>NOTE:</strong>
                    Select an impression frequency bar in order to show in the graph on the right the average visit rate reached. The green line shows the visit rate of the campaign.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '../widgets/BarChart';
import LineChart from '../widgets/LineChart';
import ConversionAnalysisGeo from '../widgets/ConversionAnalysisGeo';
import chartJsLoader from '@/modules/chartJsLoader';
import dc from 'dc';
import VueCircle from 'vue2-circle-progress'
import DcNumber from '../DcNumber';
import DcMap from '../DcMap';
import Heatmap from '@/modules/charts/heatmap';
import utils from '@/modules/utils';
import InfoTooltip from '../widgets/InfoTooltip';

let crossfilter = dc.crossfilter;


  let chartJsSettings = {
    new_default: function() {
      return {
        responsive: true,
        maintainAspectRatio:false,
        legend: {
          display: true
        },
        title: {
          display: false
        },
        scales: {
          yAxes: [{
            barPercentage: 1,
            afterTickToLabelConversion: function(q) {
              for (var i = 0; i < q.ticks.length; i++) {
                // eslint-disable-next-line
                q.ticks[i] += '%';
              }
            }
          }],
          xAxes: [{
            afterTickToLabelConversion: function(q) {
              for (var i = 0; i < q.ticks.length; i++) {
                // eslint-disable-next-line
                q.ticks[i] = utils.format.truncate(q.ticks[i], 18);
              }
            }
          }]
        },

        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
                var label = data.datasets[tooltipItem.datasetIndex].label || '';
                if (label) {
                    label += ': ';
                }
                label += Math.round(tooltipItem.yLabel * 100) / 100;
                return label + '%';
            }
          }
        },

        plugins: {
          datalabels: {
            display: true,
            align: 'end',
            anchor: 'end',
            offset: 2,
            formatter: function(value) {
              return (Math.round(value * 100) / 100) + "%";
            }
          }
        }
      }
    },
    from_report: function(report) {
      var chartSettings;
      switch(report.chart.options) {
        case 'default':
          return chartJsSettings.new_default();
        case 'default#disable-plugins':
          var settings = chartJsSettings.new_default()
          delete settings.plugins
          return settings;
        case 'none':
          return null;
        default:
          return undefined;
      }
    }
  };

   /* eslint-disable */
  export default {
    name: 'visit-analysis',
    components: {
      InfoTooltip,
      BarChart,
      LineChart,
      ConversionAnalysisGeo,
      VueCircle,
      DcNumber,
      DcMap
    },
    data: function() {
      return {
        tab_sections: {},
        tab_data_chart: {},
        visitMap: null,
        visitMapComponent: null,
        level1: 'allstates',
        perc_devices_reached: 0.0,
        perc_impressions_delivered: 0.0,

        visit_rate_number_props: null,
        device_perc_number_props: null,
        impression_perc_number_props: null,
      }
    },
    beforeRouteLeave(to, from, next) {
      this.$splashScreen.tabEnabled = true;
      next();
    },
    mounted: function() {
      this.$splashScreen.tabEnabled = false;
      this.$cursorSpinner.processing = false;
      this.$nextTick(() => {
        this.fetchData();
        this.$_am.logEvent("visit",this.$route.name,"visit-analysis",new Date().toISOString())
      })
    },

    computed: {
      conversion_analysis_distance: {
        get: function () {
          return this.tab_data_chart['conversion_analysis_distance'];
        },
        set: function (chartData) {
          this.tab_data_chart['conversion_analysis_distance'] = chartData;
        }
      },
      conversion_analysis_visits_exposed: {
        get: function () {
          return this.tab_data_chart['conversion_analysis_visits_exposed'];
        },
        set: function (chartData) {
          chartData.datasets[0].label = "Exposed";
          chartData.datasets[1].label = "Control";

          var conversion_visits_analysis_length = chartData.labels.length - 1;
          chartData.labels = chartData.labels.map(function(elt, idx) {
            switch(idx) {
              case conversion_visits_analysis_length:
                return elt + '+ visits';
              case 0:
                return elt + ' visit';
              default:
                return elt + ' visits';
            }
          });

          this.tab_data_chart['conversion_analysis_visits_exposed'];
        }
      },
      conversion_analysis_geo: {
        get: function() {
          return this.tab_data_chart['conversion_analysis_geo'];
        },
        set: function(chartData) {
          this.tab_data_chart['conversion_analysis_geo'] = chartData;
        }
      },
      conversion_analysis_timeline: {
        get: function() {
          return this.tab_data_chart['conversion_analysis_timeline'];
        },
        set: function(chartData) {
          if (chartData.datasets && chartData.datasets[0]) {
            chartData.datasets[0].label = "Exposed visit rate";
            chartData.datasets[1].label = "Control group visit rate";
          }
          this.tab_data_chart['conversion_analysis_timeline'] = chartData;
        }
      },
      selected_province: function() {
        return this.level1.toLowerCase();
      }
    },

    methods: {
      fetchData: function () {
        var self = this;

        self.setupTabSections();
        self.setupVisitRateChart();
        self.setupCharts();
        self.setupHeatmap();
      },
      setupTabSections: function() {
        var self = this;

        self.tab_reports = {
          conversion_analysis_distance: {
            data: {
              processFileType: "csv",
              url: "conversion_analysis_distance.csv"
            },
            chart: {
              pivot: "Interval",
              options: "default"
            }
          },
          conversion_analysis_geo: {
            data: {
              processFileType: "json",
              url: "conversion_analysis_geo.json",
            },
            chart: {
              options: "none"
            }
          },
          conversion_analysis_timeline: {
            data: {
              processFileType: "csv",
              url: "conversion_analysis_timeline.csv",
            },
            chart: {
              pivot: "date",
              options: "default#disable-plugins"
            }
          },
          conversion_analysis_visits_exposed: {
            data: {
              processFileType: "csv",
              url: "conversion_analysis_visits_exposed.csv",
            },
            chart: {
              pivot: "visits",
              options: "default"
            }
          }
        };

        Object.keys(self.tab_reports).map(function(report_name) {
          var report = self.tab_reports[report_name];
          var dataStore = self.$dataStore[report.data.processFileType];
          var reportUrl = report.data.url;

          dataStore(reportUrl,
            function (rawData) {
              var chartJsReport = Object.assign({},
                                                chartJsLoader.formatDataForChart(rawData, report.chart.pivot),
                                                {options: chartJsSettings.from_report(report)} );
              self[report_name] = chartJsReport;
              self.tab_data_chart[report_name] = chartJsReport;
              self.tab_sections[report_name] = chartJsReport;

              self.$reportSettings.setVisibility();
            }
          );
        });
      },
      setupCharts: function() {
        var visitAnalysisFootfallGroup = "visitAnalysisFootfallGroup";

        var dataTable = dc.dataTable("#data-table", visitAnalysisFootfallGroup);
        var self = this;

        this.dataTable = dataTable;

        self.$dataStore.csv("places.csv", function(placesCsv) {
          var placesData = crossfilter(placesCsv);
          var places = placesData.dimension(function(d) { return d["id"]; });

          self.$dataStore.csv("conversion_analysis_poi.csv", function(poiCsv) {
            for (var i = 0; i < poiCsv.length; i++) {
              var row = poiCsv[i];
              poiCsv[i] = Object.assign(row, places.filter(row["id"]).top(1)[0])
            }

            var poiData = crossfilter(poiCsv);
            var provinces = poiData.dimension(function(d) { return d["admin1"]; });

            dataTable
              .dimension(provinces)
              .group(function(d) { return false; })
              .order(d3.descending)
              .sortBy(function(d) { return +d["visit_rate"]; })
              .size(Infinity)
              .showGroups(false)
              .columns([
                {
                  label: 'Store',
                  format: function(d) { return d["poi"]; }
                },
                {
                  label: "Visit Percentage",
                  format: function(d) { return d3.format(".3f")(d["visit_rate"]) + "%"; }
                }
              ])
              .beginSlice(0)
              .endSlice(10)
              .render();

            self.$reportSettings.setVisibility();
          });
        });


        self.$dataStore.json("conversion_analysis_geo.json", function (provinceStatsJson) {
          for (var i = 0; i < provinceStatsJson.length; i++) {
            var index = utils.indexPosition(self.$shapesNamingLabel, provinceStatsJson[i].shape_id);
            if (index > -1){
              provinceStatsJson[i].province_name = self.$shapesNamingLabel[index]["value"];
            }
          }

          var provinceStatsData = crossfilter(provinceStatsJson);

          var provinces = provinceStatsData.dimension(function (d) {
              return d["province_name"];
          });

          var provincesUplift = provinces.group().reduceSum(function (d) {
              return d["uplift"] || 0;
          });

          self.$dataStore.json("map.json", function (provincesJson) {
            var d3ColorRange;
            var allUpliftValues = provincesUplift.top(provincesUplift.size());
            var largestUplift = allUpliftValues[0].value;
            var smallestUplift = allUpliftValues[provincesUplift.size() - 1].value;
            var isEmptyData = largestUplift === smallestUplift && smallestUplift === 0;

            if (isEmptyData) {
              d3ColorRange = d3.scale.linear().range(["lightgrey", "lightgrey"]).domain([0,0]);
            } else {
              var colorDomain = [0,1,2,3,4,5,6,7,8,9].map((i) => {
                return smallestUplift + ((i) * (largestUplift - smallestUplift)/10);
              });

              d3ColorRange = d3.scale.linear()
              .range(["lightgrey", "#e0f3db","#ccebc5","#a8ddb5","#7bccc4","#4eb3d3","#2b8cbe","#0868ac","#084081","#063059","#1C2B35"])
              .domain(colorDomain.map((d) => { return d > 0  ? d : 0 }))
            }

            self.visitMapComponent = {
              dcGroup: visitAnalysisFootfallGroup,
              mapJson: provincesJson,
              dimension: provinces,
              crossfilterGroup: provincesUplift,

              initFunc: function(dcMap, d3Legend, getCenterProjection, initLegend) {
                self.visitMap = dcMap;

                dcMap
                  .colors(d3ColorRange)
                  .title(function (d) {
                     return d.key + "\nUplift: " + d3.format(".2%")(d.value ? d.value : 0);
                  })
                  .transitionDuration(400);

                dcMap.reset = function() {
                  self.level1 = 'allstates';
                  dcMap.filterAll();
                  dcMap.projection(getCenterProjection(provincesJson));
                  dataTable.filterAll()
                  dc.renderAll(visitAnalysisFootfallGroup);

                  self.$reportSettings.setVisibility();
                };

                dcMap.onClick = function(d, i) {
                  var indexPosition = utils.indexPosition(allUpliftValues,d.properties.level1,"key")
                  if ( allUpliftValues[indexPosition]["value"] > 0) {
                    dc.events.trigger(function () {
                      if (dcMap.filter() === d.properties.level1) {
                        self.level1 = 'allstates';
                        dcMap.filterAll();
                        dcMap.projection(getCenterProjection(provincesJson));
                      } else {
                        self.level1 = d.properties.level1;
                        dcMap.replaceFilter(d.properties.level1);
                        dcMap.projection(getCenterProjection(d));
                      }

                      dataTable.filterAll()
                      dataTable.filter(dcMap.filter());
                      dc.renderAll(visitAnalysisFootfallGroup);
                    });
                  }
                };
                d3Legend
                  .shapeWidth(35)
                  .cells(isEmptyData ? 2 : (provinces.group().size() >= 5 ? Math.min(10, Math.floor(largestUplift * 100 - smallestUplift * 100) + 1) : 3))
                  .labelFormat(function(d) {
                    return (d === 0 ? "" : "<") + d3.format(".0%")(d);
                  });

                dcMap.render();
                initLegend(d3Legend);
                self.$reportSettings.setVisibility();
              }
            };
          });
        });
      },
      setupVisitRateChart: function() {
        var self = this;

        self.$dataStore.csv("frequency_analysis.csv", function(frequencyAnalysis) {
          var visitRateStatsGroup = 'visit-rate-stats';
          var visitFreqBarChart = dc.barChart("#converted-devices-rate", visitRateStatsGroup);

          var data = crossfilter(frequencyAnalysis),
          fcDimension1 = data.dimension(function(d) {return d["fc"];}),
          fcDimension2 = data.dimension(function(d) {return d["fc"];}),
          conversionRateGroup = fcDimension1.group().reduceSum(function(d) {return d["conversion_rate"];}),
          conversionStatsGroup = fcDimension2.groupAll().reduce(
            function(p, v) {
              p.conversion_rate_weighted_sum += +v["perc_dev"] * +v["conversion_rate"];
              p.perc_impr_sum += +v["perc_impr"];
              p.perc_dev_sum += +v["perc_dev"];
              return p;
            },
            function(p, v) {
              p.conversion_rate_weighted_sum -= +v["perc_dev"] * +v["conversion_rate"];
              p.perc_impr_sum -= +v["perc_impr"];
              p.perc_dev_sum -= +v["perc_dev"];
              return p;
            },
            function() { return { perc_dev_sum: 0, perc_impr_sum: 0, conversion_rate_weighted_sum: 0 }; }
          );

          function weightedAverage(d) {
            return d.perc_dev_sum ? d.conversion_rate_weighted_sum / d.perc_dev_sum : 0;
          }

          self.visit_rate_number_props = {
            valueAccessor: weightedAverage,
            dimension: fcDimension2,
            crossfilterGroup: conversionStatsGroup,
            dcGroup: visitRateStatsGroup
          };

          self.device_perc_number_props = {
            valueAccessor: dc.pluck("perc_dev_sum"),
            dimension: fcDimension2,
            crossfilterGroup: conversionStatsGroup,
            dcGroup: visitRateStatsGroup,
            onChange: function(d) {
              if (self.$refs.deviceRateProgress !== undefined) {
                self.$refs.deviceRateProgress.updateProgress(d.data());
              }
              self.perc_devices_reached = d.data();
            }
          };

          self.impression_perc_number_props = {
            valueAccessor: dc.pluck("perc_impr_sum"),
            dimension: fcDimension2,
            crossfilterGroup: conversionStatsGroup,
            dcGroup: visitRateStatsGroup,
            onChange: function(d) {
              if (self.$refs.impressionRateProgress !== undefined) {
                self.$refs.impressionRateProgress.updateProgress(d.data());
              }
              self.perc_impressions_delivered = d.data();
            }
          };

          var numValues = conversionRateGroup.size()
          var largestValue = conversionRateGroup.top(1)[0].value;
          var smallestValue = conversionRateGroup.top(numValues)[numValues - 1].value;

          var d3ColorRange = d3.scale.linear()
          .range(["rgb(87, 167, 221)", "rgb(17, 97, 151)"])
          .domain([smallestValue, largestValue]);

          var barWidth = 16;

          visitFreqBarChart
          .width(700)
          .height(350)
          .ordering(function(d) {
              return +d.key.split(/-|\+/)[0];
          })
          .x(d3.scale.ordinal())
          .xUnits(dc.units.ordinal)
          .y(d3.scale.linear().domain([0, largestValue * 1.05]))
          .dimension(fcDimension1)
          .group(conversionRateGroup)
          .label(function(d) {
              return d3.format(".1f")(d.y) + "%";
          })
          .transitionDuration(0)
          .renderHorizontalGridLines(true)
          .colors(d3ColorRange)
          .colorCalculator(function (d) {
              return d ? visitFreqBarChart.colors()(d.value) : '#ccc';
          })
          .on('pretransition', function(visitFreqBarChart) {
            visitFreqBarChart.selectAll('.barLabel')
            .attr('font-size', 10)
            .attr('fill', 'rgb(160, 160, 160)');

            visitFreqBarChart.selectAll('.bar')
            .attr('width', barWidth)
            .attr('x', function(d, i) {
              var slotWidth = visitFreqBarChart.effectiveWidth()/numValues;
              return +d3.select(this).attr('x') + slotWidth/2 - barWidth/2 - 2;
            });

            var lineValue = weightedAverage(conversionStatsGroup.value());
            var extra_data = [
              {
                x: visitFreqBarChart.x().range()[0],
                y: visitFreqBarChart.y()(lineValue)
              },
              {
                x: visitFreqBarChart.xAxisLength(),
                y: visitFreqBarChart.y()(lineValue)
              }
            ];

            var line = d3.svg.line()
            .x(function(d) { return d.x; })
            .y(function(d) { return d.y; })
            .interpolate('linear');

            var chartBody = visitFreqBarChart.select('g.chart-body');
            var path = chartBody.selectAll('path.extra').data([extra_data]);

            path.enter().append('path').attr({
              class: 'extra',
              stroke: 'rgba(151, 186, 66, 0.5)',
              id: 'extra-line',
              'stroke-width': 5
            });

            path.attr('d', line);

            var text = chartBody.selectAll('text.extra-label').data([0]);

            text.enter()
            .append('text')
            .classed('extra-label', true)
            .attr('text-anchor', 'end')
            .attr('dy', '-5');

            var textPath = text.selectAll('textPath').data([0]);

            textPath.enter().append('textPath');

            textPath.attr({
              class: 'extra-label',
              'xlink:href': '#extra-line',
              'startOffset': '100%',
              fill: 'rgb(151, 186, 66)',
              'font-size': '14px'
            })
            .text(d3.format(".2f")(lineValue) + "%");
          }).render();

          self.$reportSettings.setVisibility();
        });
      },
      setupHeatmap: function() {
        var self = this
        this.$dataStore.csv('conversion_analysis_heatmap.csv', (csv) => {
          self.initHeatmap('.visit-poi_impressions_time_heatmap', csv);
          self.$reportSettings.setVisibility();
        });
      },
      initHeatmap: function(ctx, data) {
        var heatmapTimeImpressionsKlass = new Heatmap({
          enable_controls: false,
          legend: {width: 500, shapeWidth: 50}
        });

        heatmapTimeImpressionsKlass.processDataFormat = function(data) {
          data.forEach(function(d) {
            d.day = d.day === "7" ?  6 : (6 - d.day);
            d.hour = +d.hour;
          });
        };

        heatmapTimeImpressionsKlass.getDayGroup = function(dimensions) {
          return dimensions.day.group().reduceSum((d) => { return d.value / 24; });
        };

        heatmapTimeImpressionsKlass.getHourGroup = function(dimensions) {
          return dimensions.hour.group().reduceSum((d) => { return d.value / 7; })
        };

        heatmapTimeImpressionsKlass.getDimensions = function (crossfilter) {
          var _self = this;
          var ndx = crossfilter ? crossfilter : _self.ndx;

          return {
            day_hour: ndx.dimension((d) => { return [+d.hour, +d.day]; }),
            day: ndx.dimension((d) => { return +d.day; }),
            hour: ndx.dimension((d) => { return +d.hour; }),
            bucket: ndx.dimension((d) => { return d.bucket; })
          };
        };


        heatmapTimeImpressionsKlass.setHeatmapRowsLabel = function (i) {
          var _self = this;
          return _self.WDAY_LABELS[i === 6 ? 6 : 5 - i];
        };

        var titleDisplay = function(d) {
          return "  Visit rate:   " + Number(d.value).toFixed(4) + "%";
        };
        heatmapTimeImpressionsKlass.getBarchartDayTitle = titleDisplay;
        heatmapTimeImpressionsKlass.getBarchartHourTitle = titleDisplay;

        heatmapTimeImpressionsKlass.getHeatmapTitle = function(d) {
          var value = Number(d.value.percentageGain)
          return value === 0 ? "" : "  Visit rate:   " + value.toFixed(4) + "%";
        };

        var heatmapObject = heatmapTimeImpressionsKlass.render(ctx, data);

        $(ctx + ' .converted-impressions-bucket button').on('click', function(e) {
          var $elt = $(e.currentTarget);
          $elt.siblings().removeClass('selected');
          $elt.addClass('selected');

          var bucketType = $elt.attr('class').match(/btn\-significance-\w*/)[0].replace('btn-significance-','');

          var ndx = heatmapObject.crossfilter = crossfilter(heatmapObject._self.data);
          var dimensions = heatmapObject.dimensions =  heatmapObject._self.getDimensions(ndx);
          var dimensionGroups = heatmapObject._self.getDimensionGroups(dimensions);


          heatmapObject.chartGroup.heatmap.dimension(dimensions.day_hour).group(dimensionGroups.day_hour);
          heatmapObject.chartGroup.days.dimension(dimensions.day).group(dimensionGroups.day);
          heatmapObject.chartGroup.hours.dimension(dimensions.hour).group(dimensionGroups.hour);

          heatmapObject.dimensions.bucket.filter(bucketType);
          dc.redrawAll(heatmapObject.chartGroupName);
        });
      }
    }
  };
</script>



<style lang="sass">
  @import '../../assets/css/charts/heatmap.scss'
</style>



// WEBPACK FOOTER //
// src/components/tabs/VisitAnalysis.vue